// extracted by mini-css-extract-plugin
export var active = "_eo-2";
export var recordingDot = "_eo-1";
export var recordingIndicator = "_eo-0";